import { generateProjectObject } from 'utils';
import { projectsServices } from 'services';
import projectsConstants from './ProjectsTypes';
import { DonationsActions, AlertActions } from 'redux/actions';
const getMyProjects = () => {
  return (dispatch) => {
    dispatch(getMyProjectsRequest());
    projectsServices
      .getMyProjects()
      .then((res) => {
        return dispatch(getMyProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getMyProjectsFailure(error.errors));
      });
  };
};

const getMyProjectsRequest = () => ({
  type: projectsConstants.GET_MY_PROJECTS_REQUEST,
});
const getMyProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_MY_PROJECTS_SUCCESS,
  projects,
});
const getMyProjectsFailure = (error) => ({
  type: projectsConstants.GET_MY_PROJECTS_FAILURE,
  error,
});

const getProjects = (perPage, page, ids) => {
  return (dispatch) => {
    dispatch(getProjectsRequest());
    projectsServices
      .getProjects(perPage, page, ids)
      .then((res) => {
        return dispatch(getProjectsSuccess(res.projects));
      })
      .catch((error) => {
        if (error.errors) {
          error.errors.map((err) => dispatch(AlertActions.error(err)));
          return dispatch(getProjectsFailure(error.errors));
        }
      });
  };
};

const getSuccessfullEventProjects = (perPage, page, ids) => {
  return (dispatch) => {
    dispatch(getSuccessfullEventProjectsRequest());
    projectsServices
      .getSuccessfullEventProjects(perPage, page, ids)
      .then((res) => {
        return dispatch(getSuccessfullEventProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getSuccessfullEventProjectsFailure(error.errors));
      });
  };
};

const getAllSuccessfullEvent = (cat) => {
  return (dispatch) => {
    dispatch(getAllSuccessfullEventsRequest());
    projectsServices
      .getAllSuccessfullEvent(cat)
      .then((res) => {
        return dispatch(getAllSuccessfullEventsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getAllSuccessfullEventsFailure(error.errors));
      });
  };
};

const getAllSuccessfullEventsRequest = () => ({
  type: projectsConstants.ALL_SUCCESSFULL_EVENT_REQUEST,
});
const getAllSuccessfullEventsSuccess = (projects) => ({
  type: projectsConstants.ALL_SUCCESSFULL_EVENT_SUCCESS,
  projects,
});

const getAllSuccessfullEventsFailure = (error) => ({
  type: projectsConstants.GET_SUCCESSFULL_EVENT_PROJECTS_FAILURE,
  error,
});

const getSuccessfullEventProjectsRequest = () => ({
  type: projectsConstants.GET_SUCCESSFULL_EVENT_PROJECTS_REQUEST,
});
const getSuccessfullEventProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_SUCCESSFULL_EVENT_PROJECTS_SUCCESS,
  projects,
});
const getSuccessfullEventProjectsFailure = (error) => ({
  type: projectsConstants.GET_SUCCESSFULL_EVENT_PROJECTS_FAILURE,
  error,
});

const getEventProjects = (perPage, page, ids) => {
  return (dispatch) => {
    dispatch(getEventProjectsRequest());
    projectsServices
      .getEventProjects(perPage, page, ids)
      .then((res) => {
        return dispatch(getEventProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getEventProjectsFailure(error.errors));
      });
  };
};

const getEventProjectsRequest = () => ({
  type: projectsConstants.GET_EVENT_PROJECTS_REQUEST,
});
const getEventProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_EVENT_PROJECTS_SUCCESS,
  projects,
});
const getEventProjectsFailure = (error) => ({
  type: projectsConstants.GET_EVENT_PROJECTS_FAILURE,
  error,
});

const getProjectsRequest = () => ({
  type: projectsConstants.GET_PROJECTS_REQUEST,
});
const getProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_PROJECTS_SUCCESS,
  projects,
});
const getProjectsFailure = (error) => ({
  type: projectsConstants.GET_PROJECTS_FAILURE,
  error,
});

const getRandomProjects = (projectId) => {
  return (dispatch) => {
    dispatch(getRandomProjectsRequest());
    projectsServices
      .getRandomProjects(projectId)
      .then((res) => {
        return dispatch(getRandomProjectsSuccess(res.projects.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getRandomProjectsFailure(error.errors));
      });
  };
};

const getRandomProjectsRequest = () => ({
  type: projectsConstants.GET_RANDOM_PROJECTS_REQUEST,
});
const getRandomProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_RANDOM_PROJECTS_SUCCESS,
  projects,
});
const getRandomProjectsFailure = (error) => ({
  type: projectsConstants.GET_RANDOM_PROJECTS_FAILURE,
  error,
});

const getSuccessfulProjects = (perPage, page, ids) => {
  return (dispatch) => {
    dispatch(getSuccessfulProjectsRequest());
    projectsServices
      .getSuccessfulProjects(perPage, page, ids)
      .then((res) => {
        return dispatch(getSuccessfulProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getSuccessfulProjectsFailure(error.errors));
      });
  };
};

const getSuccessfulProjectsRequest = () => ({
  type: projectsConstants.GET_SUCCESSFUL_PROJECTS_REQUEST,
});
const getSuccessfulProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_SUCCESSFUL_PROJECTS_SUCCESS,
  projects,
});
const getSuccessfulProjectsFailure = (error) => ({
  type: projectsConstants.GET_SUCCESSFUL_PROJECTS_FAILURE,
  error,
});

const getHomeProjects = () => {
  return (dispatch) => {
    dispatch(getHomeProjectsRequest());
    projectsServices
      .getHomeProjects()
      .then((res) => {
        return dispatch(getHomeProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error?.errors?.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getHomeProjectsFailure(error.errors));
      });
  };
};

const getHomeProjectsRequest = () => ({
  type: projectsConstants.GET_HOME_PROJECTS_REQUEST,
});
const getHomeProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_HOME_PROJECTS_SUCCESS,
  projects,
});
const getHomeProjectsFailure = (error) => ({
  type: projectsConstants.GET_HOME_PROJECTS_FAILURE,
  error,
});

const setCategoryTemp = (category) => ({
  type: projectsConstants.SET_TEMP_CATEGORY,
  payload: category,
});

const getMySupportedProjects = () => {
  return (dispatch) => {
    dispatch(getMySupportedProjectsRequest());
    projectsServices
      .getMySupportedProjects()
      .then((res) => {
        return dispatch(getMySupportedProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getMySupportedProjectsFailure(error.errors));
      });
  };
};

const getMyLikedProjects = () => {
  return (dispatch) => {
    dispatch(getMyLikedProjectsRequest());
    projectsServices
      .getMyLikedProjects()
      .then((res) => {
        return dispatch(getMyLikedProjectsSuccess(res.projects));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getMyLikedProjectsFailure(error.errors));
      });
  };
};

const getMySupportedProjectsRequest = () => ({
  type: projectsConstants.GET_MY_SUPPORTED_PROJECTS_REQUEST,
});

const getMyLikedProjectsRequest = () => ({
  type: projectsConstants.GET_MY_LIKED_PROJECTS_REQUEST,
});

const getMySupportedProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_MY_SUPPORTED_PROJECTS_SUCCESS,
  projects,
});
const getMyLikedProjectsSuccess = (projects) => ({
  type: projectsConstants.GET_MY_LIKED_PROJECTS_SUCCESS,
  projects,
});
const getMyLikedProjectsFailure = (projects) => ({
  type: projectsConstants.GET_MY_LIKED_PROJECTS_FAILURE,
  projects,
});

const getMySupportedProjectsFailure = (error) => ({
  type: projectsConstants.GET_MY_SUPPORTED_PROJECTS_FAILURE,
  error,
});

const getProjectErrorMessages = (error) => {
  const projectError = error?.errors ?? error;

  if (Array.isArray(projectError)) return projectError;
  if (projectError?.full_messages) return projectError.full_messages;
  if (projectError?.message) return [projectError.message];
  if (projectError?.error) return [projectError.error];
  if (typeof projectError === 'string' && projectError.trim()) {
    return [projectError];
  }

  return ['Projekt nicht gefunden.'];
};

const showProject = (
  url,
  noDonations = false,
  noUpdates = false,
  noRandomProjects = false
) => {
  return (dispatch) => {
    const normalizedUrl = url == null ? '' : String(url).trim();

    if (
      normalizedUrl === '' ||
      normalizedUrl === 'undefined' ||
      normalizedUrl === 'null'
    ) {
      dispatch(showProjectFailure(['Projekt nicht gefunden.']));
      return Promise.resolve(null);
    }

    dispatch(showProjectRequest());
    return projectsServices
      .showProject(normalizedUrl)
      .then((res) => {
        if (!noUpdates) {
          dispatch(getProjectUpdates(res.project.id));
        }
        if (!noRandomProjects) {
          dispatch(getRandomProjects(res.project.id));
        }
        if (!noDonations) {
          dispatch(DonationsActions.getProjectDonations(res.project.id, 3));
        }
        return dispatch(showProjectSuccess({ ...res.project, url: normalizedUrl }));
      })
      .catch((error) => {
        const errorMessages = getProjectErrorMessages(error);
        errorMessages.forEach((message) =>
          dispatch(AlertActions.error(message))
        );
        return dispatch(showProjectFailure(errorMessages));
      });
  };
};

const showProjectRequest = () => ({
  type: projectsConstants.SHOW_PROJECT_REQUEST,
});
const showProjectSuccess = (project) => ({
  type: projectsConstants.SHOW_PROJECT_SUCCESS,
  project,
});
const showProjectFailure = (error) => ({
  type: projectsConstants.SHOW_PROJECT_FAILURE,
  error,
});

const createDraft = (project) => {
  return (dispatch) => {
    dispatch(createDraftRequest());
    projectsServices
      .createDraft(project)
      .then((res) => {
        localStorage.setItem(
          'projectDraft',
          JSON.stringify(generateProjectObject(res.project))
        );
        return dispatch(createDraftSuccess(res.project));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(createDraftFailure(error.errors));
      });
  };
};

const createDraftRequest = () => ({
  type: projectsConstants.CREATE_DRAFT_REQUEST,
});
const createDraftSuccess = (project) => ({
  type: projectsConstants.CREATE_DRAFT_SUCCESS,
  project,
});
const createDraftFailure = (error) => ({
  type: projectsConstants.CREATE_DRAFT_FAILURE,
  error,
});

const updateDraft = (projectId, project, currentStep, submit, isView ) => {
  // TODO:
  const keyLength = Object.keys(project)?.length;
  if (keyLength > 0) {
    if (project?.category_ids) {
      const categoryIds = [String(project?.category_ids)];
      project.category_ids = categoryIds;
    }
  }
  return (dispatch) => {
    dispatch(updateDraftRequest());
    projectsServices
      .updateDraft(projectId, project)
      .then((res) => {
        localStorage.setItem(
          'projectDraft',
          JSON.stringify(generateProjectObject(res.project))
        );
        if (currentStep) {
          dispatch(AlertActions.success('Dein Projekt wurde aktualisiert.'));
        }
        if (submit) {
          return dispatch(submitDraft(projectId));
        }
        return dispatch(updateDraftSuccess(res.project, currentStep));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(updateDraftFailure(error.errors));
      });
  };
};

const updateDraftRequest = () => ({
  type: projectsConstants.UPDATE_DRAFT_REQUEST,
});
const updateDraftSuccess = (project, currentStep, goTo) => ({
  type: projectsConstants.UPDATE_DRAFT_SUCCESS,
  project,
  currentStep: goTo ? goTo :  currentStep === 7 ? currentStep : currentStep + 1,
});
const updateDraftFailure = (error) => ({
  type: projectsConstants.UPDATE_DRAFT_FAILURE,
  error,
});

const duplicateDraft = (projectId, url) => {
  return (dispatch) => {
    dispatch(duplicateDraftRequest());
    projectsServices
      .duplicateDraft(projectId, url)
      .then((res) => {
        localStorage.setItem("duplicated", "true");
        window.open(`/start-project/${res.project.id}`, '_self');
        dispatch(AlertActions.success('Dein Projekt wurde dupliziert.'));
        return dispatch(duplicateDraftSuccess(res.project));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        dispatch(AlertActions.error('Ein Fehler ist beim Duplizieren aufgetreten.'));
        return dispatch(duplicateDraftFailure(error.errors));
      });
  };
};

const duplicateDraftRequest = () => ({
  type: projectsConstants.DUPLICATE_DRAFT_REQUEST,
});
const duplicateDraftSuccess = (project) => ({
  type: projectsConstants.DUPLICATE_DRAFT_SUCCESS,
  project,
});
const duplicateDraftFailure = (error) => ({
  type: projectsConstants.DUPLICATE_DRAFT_FAILURE,
  error,
});

const uploadFiles = (projectId, formData) => {
  return (dispatch) => {
    dispatch(uploadFilesRequest());
    projectsServices
      .uploadFiles(projectId, formData)
      .then((res) => {
        dispatch(AlertActions.success('Dateien erfolgreich hochgeladen.'));
        dispatch(uploadFilesSuccess());
        return dispatch(updateDraft(projectId, {}));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        dispatch(AlertActions.error('Ein Fehler ist beim Duplizieren aufgetreten.'));
        return dispatch(uploadFilesFailure(error.errors));
      });
  };
};

const uploadFilesRequest = () => ({
  type: projectsConstants.UPLOAD_FILES_REQUEST,
});
const uploadFilesSuccess = (project) => ({
  type: projectsConstants.UPLOAD_FILES_SUCCESS,
  project: project,
});
const uploadFilesFailure = (error) => ({
  type: projectsConstants.UPLOAD_FILES_FAILURE,
  error,
});

const deleteDraft = (projectId) => {
  return (dispatch) => {
    dispatch(deleteDraftRequest());
    projectsServices
      .deleteDraft(projectId)
      .then((res) => {
        dispatch(AlertActions.success('Dein Projekt wurde erfolgreich gelöscht.'));
        return dispatch(deleteDraftSuccess(res));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        dispatch(AlertActions.error('Ein Fehler ist beim Löschen aufgetreten.'));
        return dispatch(deleteDraftFailure(error.errors));
      });
  };
};

const deleteDraftRequest = () => ({
  type: projectsConstants.DELETE_DRAFT_REQUEST,
});
const deleteDraftSuccess = (project) => ({
  type: projectsConstants.DELETE_DRAFT_SUCCESS,
  project,
});
const deleteDraftFailure = (error) => ({
  type: projectsConstants.DELETE_DRAFT_FAILURE,
  error,
});

const deleteDraftReload = () => {
  return (dispatch) => {
    return dispatch(deleteDraftReloadSuccess());
  }
}

const deleteDraftReloadSuccess = () => ({
  type: projectsConstants.DELETE_DRAFT_RELOAD,
})

const reEditDraft = (projectId, project, currentStep) => {
  return (dispatch) => {
    dispatch(reEditDraftRequest());
    projectsServices
      .reEditDraft(projectId, project)
      .then((res) => {
        localStorage.setItem(
          'projectDraft',
          JSON.stringify(generateProjectObject(res.project))
        );
        if (currentStep) {
          dispatch(AlertActions.success('Your Project Change to Draft'));
        }

        return dispatch(reEditDraftSuccess(res.project));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(reEditDraftFailure(error.errors));
      });
  };
};

const reEditDraftRequest = () => ({
  type: projectsConstants.REEDIT_DRAFT_REQUEST,
});
const reEditDraftSuccess = (project) => ({
  type: projectsConstants.REEDIT_DRAFT_SUCCESS,
  project,
  currentStep: 1,
});
const reEditDraftFailure = (error) => ({
  type: projectsConstants.REEDIT_DRAFT_FAILURE,
  error,
});

const uploadImages = (projectId, project, currentStep) => {
  return (dispatch) => {
    dispatch(uploadImagesRequest());
    projectsServices
      .uploadImages(projectId, project)
      .then((res) => {
        localStorage.setItem(
          'projectDraft',
          JSON.stringify(generateProjectObject(res.project))
        );
        return dispatch(uploadImagesSuccess(res.project, currentStep));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(uploadImagesFailure(error.errors));
      });
  };
};

const uploadImagesRequest = () => ({
  type: projectsConstants.UPDATE_DRAFT_REQUEST,
});
const uploadImagesSuccess = (project, currentStep) => ({
  type: projectsConstants.UPDATE_DRAFT_SUCCESS,
  project,
  currentStep: currentStep === 10 ? currentStep : currentStep + 1,
});
const uploadImagesFailure = (error) => ({
  type: projectsConstants.UPDATE_DRAFT_FAILURE,
  error,
});

const updateDraftAndImages = (
  projectId,
  projectJSON,
  projectImages,
  currentStep,
  goTo
) => {
  return (dispatch) => {
    console.log("UPDATE", projectId, projectJSON, projectImages, currentStep, goTo)
    dispatch(updateDraftRequest());
    // Send the Images
    projectsServices
      .uploadImages(projectId, projectImages)
      .then((res) => {
        // Send the JSON
        projectsServices
          .updateDraft(projectId, projectJSON)
          .then((res) => {
            localStorage.setItem(
              'projectDraft',
              JSON.stringify(generateProjectObject(res.project))
            );
            if (currentStep) {
              dispatch(
                AlertActions.success('Dein Projekt wurde aktualisiert.')
              );
            }
            console.log("GOTO", goTo, currentStep)

            return dispatch(updateDraftSuccess(res.project, currentStep, goTo));
          })
          .catch((error) => {
            error.errors.map((err) => dispatch(AlertActions.error(err)));
            return dispatch(updateDraftFailure(error.errors));
          });
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(uploadImagesFailure(error.errors));
      });
  };
};

const updateDraftReward = (projectId, rewardJSON, rewardImage, currentStep) => {
  return async (dispatch) => {
    dispatch(updateDraftRequest());

    try {
      // Send the JSON
      const rewardsCreateReq = await projectsServices.createEditReward(
        projectId,
        rewardJSON
      );

      // Get the ID from the request
      const rewardId = rewardsCreateReq.project.id;

      // Send the Image with the ID
      await projectsServices.uploadRewardImage(rewardId, rewardImage);

      // Send the JSON empty again to get correct data
      const finalUpdateReq = await projectsServices.updateDraft(projectId, {});

      localStorage.setItem(
        'projectDraft',
        JSON.stringify(generateProjectObject(finalUpdateReq.project))
      );
      if (currentStep) {
        dispatch(
          AlertActions.success(
            'Danke für deine Nachricht! Wir melden uns bald bei dir, inshaAllah.'
          )
        );
      }

      return dispatch(updateDraftSuccess(finalUpdateReq.project, currentStep));
    } catch (error) {
      console.log(error);
    }
  };
};

const deleteDraftReward = (projectId, rewardId, currentStep) => {
  return async (dispatch) => {
    dispatch(updateDraftRequest());

    try {
      // Send Delete
      await projectsServices.deleteReward(rewardId);

      // Send the JSON empty again to get correct data
      const finalUpdateReq = await projectsServices.updateDraft(projectId, {});

      localStorage.setItem(
        'projectDraft',
        JSON.stringify(generateProjectObject(finalUpdateReq.project))
      );
      if (currentStep) {
        dispatch(AlertActions.success('Dein Projekt wurde aktualisiert.'));
      }

      return dispatch(updateDraftSuccess(finalUpdateReq.project, currentStep));
    } catch (error) {
      console.log(error);
    }
  };
};

const getBusinessType = (project) => {
  return (dispatch) => {
    dispatch(getBusinessTypeRequest());
    projectsServices
      .getBusinessType(project)
      .then((res) => {
        return dispatch(getBusinessTypeSuccess(res));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getBusinessTypeFailure(error.errors));
      })
  }
}

const getBusinessTypeRequest = () => ({
  type: projectsConstants.GET_BUSINESS_TYPE_REQUEST,
});
const getBusinessTypeSuccess = (res) => ({
  type: projectsConstants.GET_BUSINESS_TYPE_SUCCESS,
  res,
});
const getBusinessTypeFailure = (error) => ({
  type: projectsConstants.GET_BUSINESS_TYPE_FAILURE,
  error,
});

const submitDraft = (project) => {
  return (dispatch) => {
    dispatch(submitDraftRequest());
    projectsServices
      .submitDraft(project)
      .then((res) => {
        localStorage.setItem(
          'projectDraft',
          JSON.stringify(generateProjectObject(res.project))
        );
        window.open(`/submitted`, '_self');
        dispatch(AlertActions.success('Dein Projekt wurde eingereicht.'));
        return dispatch(submitDraftSuccess(res.project));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(submitDraftFailure(error.errors));
      });
  };
};

const submitDraftRequest = () => ({
  type: projectsConstants.SUBMIT_DRAFT_REQUEST,
});
const submitDraftSuccess = (project) => ({
  type: projectsConstants.SUBMIT_DRAFT_SUCCESS,
  project,
});
const submitDraftFailure = (error) => ({
  type: projectsConstants.SUBMIT_DRAFT_FAILURE,
  error,
});

const checkUrl = (url) => {
  return (dispatch) => {
    dispatch(checkUrlRequest());
    projectsServices
      .checkUrl(url)
      .then((res) => {
        return dispatch(checkUrlSuccess(res.isUniq));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(checkUrlFailure(error.errors));
      });
  };
};

const checkUrlRequest = () => ({
  type: projectsConstants.CHECK_URL_REQUEST,
});
const checkUrlSuccess = (isUniq) => ({
  type: projectsConstants.CHECK_URL_SUCCESS,
  isUniq,
});
const checkUrlFailure = (error) => ({
  type: projectsConstants.CHECK_URL_FAILURE,
  error,
});

const getProjectCategories = () => {
  return (dispatch) => {
    dispatch(getProjectCategoriesRequest());
    projectsServices
      .getProjectCategories()
      .then((res) => {
        return dispatch(getProjectCategoriesSuccess(res.categories));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getProjectCategoriesFailure(error.errors));
      });
  };
};

const getProjectAdminCategories = () => {
  return (dispatch) => {
    dispatch(getProjectAdminCategoriesRequest());
    projectsServices
      .getProjectAdminCategories()
      .then((res) => {
        return dispatch(getProjectAdminCategoriesSuccess(res.adminCategories));
      })
      .catch((error) => {
        error?.errors?.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getProjectAdminCategoriesFailure(error.errors));
      });
  };
};

const getProjectCategoriesRequest = () => ({
  type: projectsConstants.GET_CATEGORIES_REQUEST,
});
const getProjectAdminCategoriesRequest = () => ({
  type: projectsConstants.GET_ADMIN_CATEGORIES_REQUEST,
});
const getProjectAdminCategoriesSuccess = (adminCategories) => ({
  type: projectsConstants.GET_ADMIN_CATEGORIES_SUCCESS,
  adminCategories,
});
const getProjectAdminCategoriesFailure = (error) => ({
  type: projectsConstants.GET_ADMIN_CATEGORIES_FAILURE,
  error,
});

const getProjectCreationCategories = () => {
  return (dispatch) => {
    dispatch(getProjectCreationCategoriesRequest());
    projectsServices
      .getProjectCreationCategories()
      .then((res) => {
        return dispatch(
          getProjectCreationCategoriesSuccess(res.categoriesCreation)
        );
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getProjectCreationCategoriesFailure(error.errors));
      });
  };
};

const getProjectCreationCategoriesRequest = () => ({
  type: projectsConstants.GET_CREATION_CATEGORIES_REQUEST,
});
const getProjectCreationCategoriesSuccess = (categoriesCreation) => ({
  type: projectsConstants.GET_CREATION_CATEGORIES_SUCCESS,
  categoriesCreation,
});
const getProjectCreationCategoriesFailure = (error) => ({
  type: projectsConstants.GET_CREATION_CATEGORIES_FAILURE,
  error,
});

const getProjectCategoriesSuccess = (categories) => ({
  type: projectsConstants.GET_CATEGORIES_SUCCESS,
  categories,
});
const getProjectCategoriesFailure = (error) => ({
  type: projectsConstants.GET_CATEGORIES_FAILURE,
  error,
});

const getProjectUpdates = (projectId) => {
  return (dispatch) => {
    dispatch(getProjectUpdatesRequest());
    projectsServices
      .getProjectUpdates(projectId)
      .then((res) => {
        return dispatch(getProjectUpdatesSuccess(res.updates));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getProjectUpdatesFailure(error.errors));
      });
  };
};

const getProjectUpdatesRequest = () => ({
  type: projectsConstants.GET_UPDATES_REQUEST,
});
const getProjectUpdatesSuccess = (updates) => {
  return {
    type: projectsConstants.GET_UPDATES_SUCCESS,
    updates,
  };
};
const getProjectUpdatesFailure = (error) => ({
  type: projectsConstants.GET_UPDATES_FAILURE,
  error,
});

const createProjectUpdates = (update, callback, onProgress) => {
  return (dispatch) => {
    dispatch(createProjectUpdatesRequest());

    projectsServices
      .createProjectUpdates(update, onProgress)
      .then((res) => {
        return projectsServices.getProjectUpdates(res.update.project_id);
      })
      .then((res) => {
        dispatch(
          AlertActions.success(
            'Dein Update wurde auf deiner Projektseite veröffentlicht.'
          )
        );

        dispatch(createProjectUpdatesSuccess(res.updates));

        if (callback) {
          callback();
        }
      })
      .catch((error) => {
        if (error.errors) {
          error.errors.map((err) => dispatch(AlertActions.error(err)));
          dispatch(createProjectUpdatesFailure(error.errors));
        } else {
          dispatch(AlertActions.error('Ein Fehler ist aufgetreten.'));
          dispatch(createProjectUpdatesFailure(error));
        }
      });
  };
};

const createProjectUpdatesRequest = () => ({
  type: projectsConstants.CREATE_UPDATE_REQUEST,
});
const createProjectUpdatesSuccess = (updates) => ({
  type: projectsConstants.CREATE_UPDATE_SUCCESS,
  updates,
});
const createProjectUpdatesFailure = (error) => ({
  type: projectsConstants.CREATE_UPDATE_FAILURE,
  error,
});

const deleteProjectUpdates = (projectId, updateId) => {
  return (dispatch) => {
    dispatch(deleteProjectUpdatesRequest());
    projectsServices
      .deleteProjectUpdates(updateId)
      .then(() => {
        projectsServices.getProjectUpdates(projectId).then((res) => {
          dispatch(AlertActions.success('Your Update has been Deleted'));
          return dispatch(deleteProjectUpdatesSuccess(res.updates));
        });
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(deleteProjectUpdatesFailure(error.errors));
      });
  };
};

const deleteProjectUpdatesRequest = () => ({
  type: projectsConstants.DELETE_UPDATE_REQUEST,
});
const deleteProjectUpdatesSuccess = (updates) => ({
  type: projectsConstants.DELETE_UPDATE_SUCCESS,
  updates,
});
const deleteProjectUpdatesFailure = (error) => ({
  type: projectsConstants.DELETE_UPDATE_FAILURE,
  error,
});

const getProjectStatus = (id) => {
  return (dispatch) => {
    dispatch(getProjectStatusRequest());
    projectsServices
      .getProjectStatus(id)
      .then((res) => {
        return dispatch(getProjectStatusSuccess(res.projectStatus));
      })
      .catch((error) => {
        error?.errors?.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(getProjectStatusFailure(error.errors));
      });
  };
};

const getProjectStatusRequest = () => ({
  type: projectsConstants.GET_PROJECT_STATUS_REQUEST,
});
const getProjectStatusSuccess = (projectStatus) => ({
  type: projectsConstants.GET_PROJECT_STATUS_SUCCESS,
  projectStatus,
});
const getProjectStatusFailure = (error) => ({
  type: projectsConstants.GET_PROJECT_STATUS_FAILURE,
  error,
});

const removeEdit = (id) => {
  return (dispatch) => {
    dispatch(removeEditRequest());
    projectsServices
      .removeEdit(id)
      .then((res) => {
        return dispatch(removeEditSuccess(res.projectStatus));
      })
      .catch((error) => {
        error.errors.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(removeEditFailure(error.errors));
      });
  };
};

const removeEditRequest = () => ({
  type: projectsConstants.REMOVE_EDIT_REQUEST,
});
const removeEditSuccess = (projectStatus) => ({
  type: projectsConstants.REMOVE_EDIT_SUCCESS,
  projectStatus,
});
const removeEditFailure = (error) => ({
  type: projectsConstants.REMOVE_EDIT_FAILURE,
  error,
});

const clearProject = () => {
  return (dispatch) => {
    dispatch(clearProjectSuccess());
  };
};
const clearProjectSuccess = () => ({
  type: projectsConstants.CLEAR_PROJECT_SUCCESS,
});

const handleSteps = (step) => {
  return (dispatch) => {
    dispatch({
      type: projectsConstants.HANDLE_STEPS,
      step,
    });
  };
};

const likeProject = (projectId) => {
  return (dispatch) => {
    dispatch(likeProjectRequest());
    projectsServices
      .likeProject(projectId)
      .then((res) => {
        return dispatch(likeProjectSuccess(res));
      })
      .catch((error) => {
        error?.errors?.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(likeProjectFailure(error?.errors));
      });
  };
};

const likeProjectRequest = () => ({
  type: projectsConstants.LIKE_PROJECT_REQUEST,
});
const likeProjectSuccess = (project) => ({
  type: projectsConstants.LIKE_PROJECT_SUCCESS,
  project,
});
const likeProjectFailure = (error) => ({
  type: projectsConstants.LIKE_PROJECT_FAILURE,
  error,
});

const unlikeProject = (projectId) => {
  return (dispatch) => {
    dispatch(unlikeProjectRequest());
    projectsServices
      .unlikeProject(projectId)
      .then((res) => {
        return dispatch(unlikeProjectSuccess(res));
      })
      .catch((error) => {
        error?.errors?.map((err) => dispatch(AlertActions.error(err)));
        return dispatch(unlikeProjectFailure(error?.errors));
      });
  };
};

const unlikeProjectRequest = () => ({
  type: projectsConstants.UNLIKE_PROJECT_REQUEST,
});
const unlikeProjectSuccess = (project) => ({
  type: projectsConstants.UNLIKE_PROJECT_SUCCESS,
  project,
});
const unlikeProjectFailure = (error) => ({
  type: projectsConstants.UNLIKE_PROJECT_FAILURE,
  error,
});

const ProjectActions = {
  getMyProjects,
  getMyLikedProjects,
  getMySupportedProjects,
  getSuccessfulProjects,
  createDraft,
  updateDraft,
  duplicateDraft,
  uploadFiles,
  deleteDraft,
  deleteDraftReload,
  uploadImages,
  updateDraftAndImages,
  updateDraftReward,
  deleteDraftReward,
  submitDraft,
  getBusinessType,
  checkUrl,
  getProjectCategories,
  getProjectAdminCategories,
  getProjectCreationCategories,
  clearProject,
  showProject,
  getProjects,
  getProjectUpdates,
  createProjectUpdates,
  deleteProjectUpdates,
  handleSteps,
  reEditDraft,
  getProjectStatus,
  getRandomProjects,
  getHomeProjects,
  removeEdit,
  getEventProjects,
  getSuccessfullEventProjects,
  setCategoryTemp,
  getAllSuccessfullEvent,
  likeProject,
  unlikeProject,
};

export default ProjectActions;
